/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Promised Prepayment Constants
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

export const PROMISED_PAYMENT_GET_AMOUNT_ACTION =
    '@@b2b_portal_ui/promisedPayment/PROMISED_PAYMENT_GET_AMOUNT_ACTION';
export const PROMISED_PAYMENT_GET_AMOUNT_SUCCESS =
    '@@b2b_portal_ui/promisedPayment/PROMISED_PAYMENT_GET_AMOUNT_SUCCESS';
export const PROMISED_PAYMENT_GET_AMOUNT_FAILURE =
    '@@b2b_portal_ui/promisedPayment/PROMISED_PAYMENT_GET_AMOUNT_FAILURE';

export const PROMISED_PAYMENT_SUBMIT_ACTION =
    '@@b2b_portal_ui/promisedPayment/PROMISED_PAYMENT_SUBMIT_ACTION';
export const PROMISED_PAYMENT_SUBMIT_SUCCESS =
    '@@b2b_portal_ui/promisedPayment/PROMISED_PAYMENT_SUBMIT_SUCCESS';
export const PROMISED_PAYMENT_SUBMIT_FAILURE =
    '@@b2b_portal_ui/promisedPayment/PROMISED_PAYMENT_SUBMIT_FAILURE';
